/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Hide/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import * as fromValidate from 'Data/validate.js'
import React from 'react'
import TysiaInput from 'DesignSystem/TysiaInput/index'
import TysiaInputContent from 'DesignSystem/TysiaInput/TysiaInputContent/index'
import TysiaInputFieldMasked from 'DesignSystem/TysiaInput/TysiaInputFieldMasked/index'
import TysiaInputLabel from 'DesignSystem/TysiaInput/TysiaInputLabel/index'
import TysiaVisibility from 'DesignSystem/Svgs/TysiaVisibility/index'
import styles from './view.module.css'
import useIsHovered from 'Simple/hooks/useIsHovered'



/** @type {import('Simple/types.js').View} */
export default function Hide({
  children,
  viewPath = "/App/Account/NewPatient/Content/Form/Fields/Ssn/Hide",
  isInvalid,
  onChange
  
}) {
let [isHovered, isSelectedHovered, isHoveredBind] = useIsHovered({})
  let setFlowTo = fromFlow.useSetFlowTo(viewPath)
let newPatientPersonSsnValueData = fromData.useDataFormat({ viewPath,
context: 'new_patient',
path: 'person.ssn',
format: fromHelpers.socialSecurityNumberHide,
})
let newPatientPersonSsnIsValidData = fromData.useDataIsValid({ viewPath,
context: 'new_patient',
path: 'person.ssn',
validate: fromValidate.social_security_number,
})
let newPatientPersonSsnChangeData = fromData.useDataChange({ viewPath,
context: 'new_patient',
path: 'person.ssn',
})
let dtColorsNeutral400 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.400'
        })
  return (<React.Fragment
>
<TysiaInput
  viewPath={`${viewPath}/TysiaInput`}
 type="text"
 data="new_patient.person.ssn"
 validate="/Data/validate.js social_security_number"
 format="helpers.js socialSecurityNumberHide"
 invalid={!newPatientPersonSsnIsValidData}
 value={newPatientPersonSsnValueData}
 onChange={newPatientPersonSsnChangeData}
>
{childProps => (
<React.Fragment>
<TysiaInputLabel
{...childProps}
  viewPath={`${viewPath}/TysiaInputLabel`}
 text="SSN"
/>
<TysiaInputContent
{...childProps}
  viewPath={`${viewPath}/TysiaInputContent`}
>
{childProps => (
<React.Fragment>
<TysiaInputFieldMasked
{...childProps}
  viewPath={`${viewPath}/TysiaInputFieldMasked`}
 mask="ssn"
 placeholder="SSN"
/>
<button
  data-testid="Hide.Vertical"
  data-view-path={viewPath}
 onClick={() => setFlowTo(fromFlow.normalizePath(viewPath, '../Show'))}
 {...isHoveredBind}
 className={`views-block ${styles.Vertical}`}
>
<TysiaVisibility
  viewPath={`${viewPath}/TysiaVisibility`}
 width={13}
 height={13}
 fill2={dtColorsNeutral400}
/>
</button>
</React.Fragment>
)}
</TysiaInputContent>
</React.Fragment>
)}
</TysiaInput>
{children}
</React.Fragment>)
}